package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_country_domain_di_AddEditCountryUseCaseModule : Module get() = module {
	single() { _ -> com.essntl.features.country.domain.usecase.AddEditCountryUseCase(countryRepository=get()) } 
}
public val com.essntl.features.country.domain.di.AddEditCountryUseCaseModule.module : org.koin.core.module.Module get() = com_essntl_features_country_domain_di_AddEditCountryUseCaseModule
